import {Store,Module,ActionContext} from 'vuex'
import PageResult from '@/store/entities/page-result';
import ListModule from './list-module';
import ListMutations from './list-mutations';
import ListState from './list-state';
import Ajax from "../../lib/ajax";
import Merchant from '../entities/merchant';

interface MerchantState extends ListState<Merchant>{
    editMerchant:Merchant
}
class MerchantMutations extends ListMutations<Merchant>{

}
class MerchantModule extends ListModule<MerchantState,any,Merchant>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Merchant>(),
        loading:false,
        editMerchant:new Merchant()
    }
    actions={
        async getAll(context:ActionContext<MerchantState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Merchant/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Merchant>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<MerchantState,any>,payload:any){
            await Ajax.post('/api/services/app/Merchant/Create',payload.data);
        },
        async update(context:ActionContext<MerchantState,any>,payload:any){
            await Ajax.put('/api/services/app/Merchant/Update',payload.data);
        },
        async delete(context:ActionContext<MerchantState,any>,payload:any){
            await Ajax.delete('/api/services/app/Merchant/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<MerchantState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Merchant/Get?Id='+payload.id);
            return reponse.data.result as Merchant;
        }
    };
    mutations={
        setCurrentPage(state:MerchantState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:MerchantState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:MerchantState,merchant:Merchant){
            state.editMerchant=merchant;
        }
    }
}
const merchantModule=new MerchantModule();
export default merchantModule;